package com.applaunchkit.website

import androidx.compose.runtime.*
import com.applaunchkit.website.util.Theme
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.silk.SilkApp
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.init.registerStyleBase
import com.varabyte.kobweb.silk.style.common.SmoothColorStyle
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.Color

@InitSilk
fun initStyleSheet(ctx: InitSilkContext) {
    ctx.stylesheet.registerStyleBase("html, body") { Modifier.fillMaxHeight() }

    ctx.stylesheet.registerStyle("*") {
        // Firefox
        cssRule("") {
            Modifier
                .styleModifier {
                    property("scrollbar-width", "thin")
                    property(
                        "scrollbar-color",
                        "${Theme.Primary.rgb} ${Theme.Background.rgb}"
                    )
                }
        }

        // WebKit (Chrome, Safari, Edge)
        cssRule("::-webkit-scrollbar") {
            Modifier
                .width(8.px)
                .height(8.px)
                .backgroundColor(Theme.Background.rgb)
        }

        cssRule("::-webkit-scrollbar-thumb") {
            Modifier
                .borderRadius(10.px)
                .backgroundColor(Theme.Primary.rgb)
        }

        cssRule("::-webkit-scrollbar-corner") {
            Modifier.backgroundColor(Color.transparent)
        }
    }
}

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    SilkApp {
        Surface(SmoothColorStyle.toModifier().fillMaxHeight()) {
            content()
        }
    }
}
